import { render, staticRenderFns } from "./ProfetAiInput.vue?vue&type=template&id=1bb9d9b4&scoped=true&"
import script from "./ProfetAiInput.vue?vue&type=script&lang=js&"
export * from "./ProfetAiInput.vue?vue&type=script&lang=js&"
import style0 from "./ProfetAiInput.vue?vue&type=style&index=0&id=1bb9d9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb9d9b4",
  null
  
)

export default component.exports